import { Message } from "@scrile/api-provider/dist/api/MessagesProvider";

export function selector(message: Message) {
  return Number(message.senderId) > 0;
}

export { default } from "./MessageItem.vue";
